import React, { FC } from 'react'

import { TrustIcon } from '@Components/Icons'
import { getMobileNavEvent, IconLink, TrustIconProps } from '@Components/TrustIcons/common'

export const TrustIconDE: FC<TrustIconProps> = ({ variant }: TrustIconProps) => (
  <IconLink
    event={getMobileNavEvent('trustedshops', variant)}
    href="https://www.trustedshops.de/bewertung/info_X65F1BC0E9146075A175FFD0E17748A60.html"
    rel="noopener noreferrer"
    target="_blank"
    variant={variant}
  >
    <TrustIcon image="frontend/trust-logos/trusted-shops-logo.png" />
  </IconLink>
)
